import { NUser, FUser, MUser } from 'uniba-volto-persone/theme/images';

const getUserFoto = (props, fullcontent = false) => {
    if (!props) return null;

    const scaleOrder = [
        "great",
        "larger",
        "large",
        "teaser",
        "preview",
        "mini",
    ];

    var personaSexData;
    if (fullcontent) {
        personaSexData = props.persona_sex;
        const personaFoto = props.foto;
        if (personaFoto) return { foto: personaFoto.scales.great.download, placeholder: false };
    } else {
        personaSexData = props.getSex;
        const personaHasFoto = props.hasFoto;
        if (personaHasFoto) {
            const fotoObj = props.image_scales.foto[0];
            let foundScale = scaleOrder.find(scale => fotoObj.scales[scale]);
            const fotoUrl = foundScale
            ? fotoObj.scales[foundScale].download
            : fotoObj.download;
            return { foto: props['@id'] + "/" + fotoUrl, placeholder: false };
        }
    }
    const defaultFoto = personaSexData === 'M' ? MUser : personaSexData === 'F' ? FUser : NUser;
    return { foto: defaultFoto, placeholder: true }
}

export default getUserFoto;